export { default as useLifestyleMaterials } from './useLifestyleMaterials';
